/* =============================================================
   MAISON ANTONELLE — Header transparent scroll behavior (home only)
   ============================================================= */
(function () {
  var body = document.body;
  var ticking = false;

  function setHeights() {
    var announcementBar = document.getElementById('shopify-section-announcement-bar');
    var headerSection = document.getElementById('shopify-section-header');

    var announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    var headerHeight = headerSection ? headerSection.offsetHeight : 0;

    document.documentElement.style.setProperty('--announcement-height', announcementHeight + 'px');
    document.documentElement.style.setProperty('--total-header-height', (announcementHeight + headerHeight) + 'px');
  }

  function updateScrollState() {
    if (window.scrollY > 0) {
      body.classList.add('header-scrolled');
    } else {
      body.classList.remove('header-scrolled');
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateScrollState);
      ticking = true;
    }
  }, { passive: true });

  // Recalcule les hauteurs si la fenêtre est redimensionnée
  window.addEventListener('resize', setHeights, { passive: true });

  // Init au chargement
  setHeights();
  updateScrollState();
})();
